import {
     
    UPDATE_LAWFIRM_STARTED,    UPDATE_LAWFIRM_SUCESS,    UPDATE_LAWFIRM_FAILED,
    GET_LAWFIRM_STARTED,    GET_LAWFIRM_SUCESS,    GET_LAWFIRM_FAILED,
    ADD_LAWFIRM_STARTED,    ADD_LAWFIRM_SUCESS,    ADD_LAWFIRM_FAILED,

    UPDATE_ATTORNEY_STARTED,    UPDATE_ATTORNEY_SUCESS,    UPDATE_ATTORNEY_FAILED,
    GET_ATTORNEY_STARTED,    GET_ATTORNEY_SUCESS,    GET_ATTORNEY_FAILED,
    ADD_ATTORNEY_STARTED,    ADD_ATTORNEY_SUCESS,    ADD_ATTORNEY_FAILED,

    UPDATE_LF_CORPORATE_STARTED,    UPDATE_LF_CORPORATE_SUCESS,    UPDATE_LF_CORPORATE_FAILED,
    GET_LF_CORPORATE_STARTED,    GET_LF_CORPORATE_SUCESS,    GET_LF_CORPORATE_FAILED,
    ADD_LF_CORPORATE_STARTED,    ADD_LF_CORPORATE_SUCESS,    ADD_LF_CORPORATE_FAILED,

    GET_LAWFIRMCASEFLOW_STARTED,    GET_LAWFIRMCASEFLOW_SUCESS,    GET_LAWFIRMCASEFLOW_FAILED,
    
    GET_ALLLAWFIRM_STARTED,    GET_ALLLAWFIRM_SUCESS,    GET_ALLLAWFIRM_FAILED,
} from '../actions/LawFirm';

const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
}; 
export const visaCareFirmData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
      case UPDATE_LAWFIRM_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_LAWFIRM_SUCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_LAWFIRM_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_LAWFIRM_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_LAWFIRM_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_LAWFIRM_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   case ADD_LAWFIRM_STARTED:           
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case ADD_LAWFIRM_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case ADD_LAWFIRM_FAILED:
   return {
     ...state,
     isLoading: true,
   };
default:
  return state;
}

}

export const visaCareAttorneyData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
      case UPDATE_ATTORNEY_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_ATTORNEY_SUCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_ATTORNEY_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_ATTORNEY_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_ATTORNEY_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_ATTORNEY_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   case ADD_ATTORNEY_STARTED:           
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case ADD_ATTORNEY_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case ADD_ATTORNEY_FAILED:
   return {
     ...state,
     isLoading: true,
   };
default:
  return state;
}

}

export const visaCareCorporateData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
      case UPDATE_LF_CORPORATE_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_LF_CORPORATE_SUCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_LF_CORPORATE_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_LF_CORPORATE_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_LF_CORPORATE_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_LF_CORPORATE_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   case ADD_LF_CORPORATE_STARTED:           
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case ADD_LF_CORPORATE_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case ADD_LF_CORPORATE_FAILED:
   return {
     ...state,
     isLoading: true,
   };
default:
  return state;
}

}


export const visaCareLawFirmCaseData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
     case GET_LAWFIRMCASEFLOW_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_LAWFIRMCASEFLOW_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_LAWFIRMCASEFLOW_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   
default:
  return state;
}

}

export const lawfirmListData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
      
    case GET_ALLLAWFIRM_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_ALLLAWFIRM_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_ALLLAWFIRM_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   
default:
  return state;
}

}